module.exports = __webpack_public_path__ + "img/Icon material-dashboard copy.22a5614a.svg";